import { useAppDispatch, useAppSelector } from "hooks";
import WhoisModal from "modals/whoisModal/whoisModal";
import { memo, useEffect, useState } from "react";
import domainSlice from "reducers/domainSlice";
import uiSlice from "reducers/uiSlice";
import { gettingWhoisSelector, whoisSelector } from "selectors/domainSelectors";
import { RootState } from "store";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  background: #5e5e5e;
  color: white;
  font-size: 0.8rem;
  margin-left: 10px;
  border-radius: 8px;
  align-items: center;
  padding: 9px 15px 9px;
  text-transform: uppercase;
  cursor: pointer;
  &:hover {
    background: #3a3a3a;
  }
`;

interface WhoisButtonProps {
  name: string;
  records?: string[] | undefined;
  onRecordsLoaded?: (records: string[]) => void;
}

const WhoisButton = (props: WhoisButtonProps) => {
  const dispatch = useAppDispatch();

  const { records, name, onRecordsLoaded } = props;

  const [whoisVisible, setWhoisVisible] = useState(false);

  const handleWhoisClick = () => {
    if (records === undefined) {
      dispatch(domainSlice.actions.getWhois(name));
    }
    dispatch(uiSlice.actions.showWhoisModal());
    setWhoisVisible(true);
  };

  const whois = useAppSelector((state: RootState) => whoisSelector(state));

  useEffect(() => {
    if (whoisVisible && whois && whois.records && onRecordsLoaded) {
      onRecordsLoaded(whois.records);
    }
  }, [whois, whoisVisible, onRecordsLoaded]);

  const gettingWhois = useAppSelector((state: RootState) =>
    gettingWhoisSelector(state),
  );

  const handleWhoisCloseClick = () => {
    dispatch(uiSlice.actions.hideWhoisModal());
    setWhoisVisible(false);
  };

  return (
    <>
      <Wrapper onClick={handleWhoisClick}>Whois</Wrapper>
      {whoisVisible && (
        <WhoisModal
          name={name}
          recordsLoading={records !== undefined ? false : gettingWhois}
          records={records ?? whois?.records}
          visible={true}
          onClose={handleWhoisCloseClick}
        />
      )}
    </>
  );
};

export default memo(WhoisButton);
